<template>
  <!--体验签署-->
  <div class="experience-sign">
    <form>
      <h1 class="f-weight__500 text-center font-small title">体验签署</h1>
      <div class="title-img"><img src="../../static/images/tpl/logo.png" /></div>
      <div class="ms mb30">【本次签署仅作演示体验使用，无法律效力】</div>
      <p>
        <strong><span style="font-family: 微软雅黑;">&nbsp; &nbsp; &nbsp; &nbsp;君子签</span></strong><span style="font-family: 微软雅黑;">是易保全旗下国内专业的区块链电子签署平台，以领先的区块链技术为基础，结合全证据链原创技术，通过改造传统签署模式，打造“区块链+司法+电子签署”创新模式，主要为金融、教培、人力资源、房地产、物流运输、供应链、医疗医药、电子政务等行业企业及政府机构，提供</span><strong><span style="font-family: 微软雅黑;">“实名认证、在线签署、合同智能管理、电子签章、区块链存证、全证据链保全、司法服务”</span></strong><span style="font-family: 微软雅黑;">等一站式电子签署服务及行业定制化解决方案，能够有效解决传统纸质合同</span><strong><span style="font-family: 微软雅黑;">“签署效率低、成本高、管理难、风险大”</span></strong><span style="font-family: 微软雅黑;">等痛点，赋能企业降本提效，节能安全，实现数字化转型升级。</span>
      </p>
      <p>
        <span style="font-family: 微软雅黑;"><br/></span>
      </p>
      <p style="text-align: center;margin: 5px 0;">
        <strong><span style="font-family: 微软雅黑;font-size: 16px">3大环节12大服务</span></strong>
      </p>
      <p style="text-align:center">
        <strong><span style="font-family: 微软雅黑;font-size: 16px">区块链全生命周期电子合同服务</span></strong>
      </p>
      <p style="text-align: center;margin: 5px 0;">
        <img width="554" height="272" src="../../static/images/tpl/expro1.png"/><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
      </p>
      <p>
        <span style="font-family: 微软雅黑;font-size: 16px">&nbsp; &nbsp; &nbsp; 君子签目前已获得国家网信办</span><span style="font-family: 微软雅黑;font-size: 16px">区块链信息服务备案</span><span style="font-family: 微软雅黑;font-size: 16px"><span style="font-family:微软雅黑">（备案号：渝网信备</span><span style="font-family:微软雅黑">50011220697819890019号）、ISO27001信息安全管</span></span><span style=";font-family:微软雅黑;font-size:16px">理</span><span style="font-family: 微软雅黑;font-size: 16px">认证</span><span style="font-family: 微软雅黑;font-size: 16px">和公安部等保三级认证（金融级别）</span><span style="font-family: 微软雅黑;font-size: 16px">，并与</span><span style="font-family: 微软雅黑;font-size: 16px">国内多家</span><span style="font-family: 微软雅黑;font-size: 16px">公证处、</span><span style="font-family: 微软雅黑;font-size: 16px">互联网法院、仲裁委、</span><span style="font-family: 微软雅黑;font-size: 16px">律所</span><span style="font-family: 微软雅黑;font-size: 16px">等</span><span style="font-family: 微软雅黑;font-size: 16px">建立合作，提供完善的</span><span style="font-family: 微软雅黑;font-size: 16px">司法保障</span><span style="font-family: 微软雅黑;font-size: 16px">服务</span><span style="font-family: 微软雅黑;font-size: 16px">体系，让合同签署更加高效便捷、安全合规</span><span style="font-family: 微软雅黑;font-size: 16px">。</span>
      </p>
      <p>
        <span style="font-family: 微软雅黑;font-size: 16px"><span style="font-family:微软雅黑">截止到</span><span style="font-family:微软雅黑">2021年6月，君子签累计签署量突破22亿，日均签署量突破400万，已服务7400万+用户，典型客户包括中国农业银行、中建投租赁、国药集团、华宇集团、旭辉集团、韵达集团、富士康、重庆建工集团、新疆旅游局、分众传媒、拉卡拉、忽米网等。</span></span>
      </p>
      <p>
        <span style="font-family: 微软雅黑;font-size: 16px"><span style="font-family:微软雅黑"><br/></span></span>
      </p>
      <p style="text-align: center;">
        <strong><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;&nbsp;&nbsp;&nbsp;核心优势</span></strong>
      </p>
      <p>
        <span style="font-family: 微软雅黑;font-size: 16px"><span style="font-family:微软雅黑">&nbsp; &nbsp; &nbsp; 保全链开放平台</span><span style="font-family:微软雅黑">——是由易保全电子数据保全中心结合区块链技术和自主发明专利，联合公证处、仲裁委、司法鉴定所、版权机构、数字认证中心、法院等机构组建的联盟区块链平台。客户上传的数据会同步储存至10+权威机构节点服务器，实现同步收录采信，保证存证数据不可篡改，确保电子数据成为合法有效的电子证据。</span></span>
      </p>
      <p style="text-align:center;margin: 5px 0;">
        <img width="381" height="257" src="../../static/images/tpl/expro2.png"/><strong><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p>
        <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
      </p>
      <p style="text-align: center;">
        <strong><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;&nbsp;&nbsp;&nbsp;全证据链</span></strong>
      </p>
      <p>
        <span style="font-family: 微软雅黑;font-size: 16px">&nbsp; &nbsp; &nbsp; 君子签通过签署全证据链原创技术，可以记录用户签署产生的全过程关键细节，包括签署终端、时间、地理位置、现场音视频、人脸识别视频存证等，有效保障合同</span><span style="font-family: 微软雅黑;font-size: 16px">信息安全，</span><span style="font-family: 微软雅黑;font-size: 16px">合同</span><span style="font-family: 微软雅黑;font-size: 16px">签署合规有效</span><span style="font-family: 微软雅黑;font-size: 16px">。</span>
      </p>
      <p style="text-align: center;margin: 5px 0;">
        <img width="552" height="151" src="../../static/images/tpl/expro3.png"/><span style=";font-family:宋体;font-size:14px">&nbsp;</span>
      </p>
      <p style="margin-right:0;margin-bottom:0">
        <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
      </p>
      <p style="margin-right: 0px; margin-bottom: 0px; text-align: center;">
        <strong><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;&nbsp;&nbsp;&nbsp;司法服务能力</span></strong>
      </p>
      <p style="margin-right:0;margin-bottom:0">
        <span style="font-family: 微软雅黑;font-size: 16px">&nbsp; &nbsp; &nbsp; 与</span><span style="font-family: 微软雅黑;font-size: 16px">权威司法机构</span><span style="font-family: 微软雅黑;font-size: 16px">系统底层互通</span><span style="font-family: 微软雅黑;font-size: 16px">，存证的电子数据</span><span style="font-family: 微软雅黑;font-size: 16px">与司法机构同步存储、同步存证，并可实时查询验证，</span><span style="font-family: 微软雅黑;font-size: 16px">若遇纠纷，</span><span style="font-family: 微软雅黑;font-size: 16px">可在线出具</span><span style="font-family: 微软雅黑;font-size: 16px">公证处</span><span style="font-family: 微软雅黑;font-size: 16px">、</span><span style="font-family: 微软雅黑;font-size: 16px">仲裁委</span><span style="font-family: 微软雅黑;font-size: 16px">、</span><span style="font-family: 微软雅黑;font-size: 16px">互联网法院等司法机构直接采信</span><span style="font-family: 微软雅黑;font-size: 16px">的电子证据。</span>
      </p>
      <p>
        <img width="620" src="../../static/images/tpl/expro4.png"/><span style=";font-family:Calibri;font-size:14px">&nbsp;</span>
      </p>
      <p>
        <br/>
      </p>
      <div class="bottom-img">
        <div>
          <img class="mb20" src="../../static/images/tpl/qr1.png" /><br />
          2分钟了解君子签
        </div>
        <div>
          <img class="mb20" src="../../static/images/tpl/qr2.png" /><br />
          2关注官方公众号
        </div>
      </div>
      <div class="cel mt60 pd10">
        <div class="cel-content font-bold">签署体验人盖章：</div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: "experience-sign",
    data() {
      return {
        form: {}
      }
    }
  }
</script>

<style lang="less" scoped>
  .experience-sign {
    font-size: 16px;
    // color: #666666;
    font-family: 微软雅黑 !important;
    margin-bottom: 1em;
  }

  .ms {
    color: #b6b4b4;
    font-size: 14px;
    text-indent: initial;
    text-align: center;
  }

  .pd10 {
    padding-bottom: 10px;
  }

  .mb30 {
    margin-bottom: 30px;
  }

  @import "../../assets/style/sysTpl";
  form p{
    text-indent: 0em;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// components/sys-contract/exper.vue